<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Table of contents</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="table-of-contents">
<p class="chap-ttl"><span class="epub-bold-normal-allcaps"><a id="pv">Contents</a></span></p><a id="pv">
</a><p class="bkfm-chap-ttl"><a id="pv"></a><a href="#/Preface"><span class="epub-italic-normal-normal">Preface</span></a></p>
<p class="bkfm-chap-ttl-0"><a href="#/Abbreviations"><span class="epub-italic-normal-normal">List of abbreviations</span></a></p>
<p class="bkfm-toc-ttl">  <a href="#/Chapter01">1  Why read Romans? Eight brief reasons</a></p>
<p class="bkfm-toc-ttl">  <a href="#/Chapter02">2  Strategies of interpretation: three essential strategies for Romans</a></p>
<p class="bkfm-toc-ttl">  <a href="#/Chapter03">3  Nine further strategies often useful for parts of Romans</a></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter04" title="Link target outside of Sample">4  The reception history of Romans</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter05" title="Link target outside of Sample">5  The textual criticism and integrity of Romans</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter06" title="Link target outside of Sample">6  Paul, traveller and citizen of Rome</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter07" title="Link target outside of Sample">7  Paul introduces himself and the theme of the gospel (1.1–17)</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter08" title="Link target outside of Sample">8  The Gentile world judged and alienated from God (1.18–32)</span></p>
<p class="bkfm-toc-ttl">  <span href="#/Chapter09" title="Link target outside of Sample">9  The Jewish world as moral critic (2.1—3.8)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter10" title="Link target outside of Sample">10  Judgement and grace on all: redemption and atonement (3.9–31)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter11" title="Link target outside of Sample">11  The promise of the covenant God; trust, the test case of Abraham (4.1–25)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter12" title="Link target outside of Sample">12  Peace with God (5.1–11)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter13" title="Link target outside of Sample">13  Christ and Adam: humanity and the new humanity (5.12–21)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter14" title="Link target outside of Sample">14  Dead to sin; alive to God (6.1–23)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter15" title="Link target outside of Sample">15  Free from the condemnation of the law (7.1–25)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter16" title="Link target outside of Sample">16  Life characterized by the Holy Spirit’s indwelling (8.1–17)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter17" title="Link target outside of Sample">17  The renewal of all things: suffering and future glory (8.18–39)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter18" title="Link target outside of Sample">18  Israel’s unbelief: filling a gap in Paul’s argument (9.1–29)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter19" title="Link target outside of Sample">19  God’s faithfulness and Israel’s responsibility (9.30—10.21)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter20" title="Link target outside of Sample">20  The salvation of ‘all Israel’ (11.1–36</span>)</p>
<p class="bkfm-toc-ttl"><span href="#/Chapter21" title="Link target outside of Sample">21  The outworking of the Christian life: sacrifice and worship  (12.1–21)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter22" title="Link target outside of Sample">22  Christian obligations (13.1–14)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter23" title="Link target outside of Sample">23  Mutual welcome and respect: ‘the strong’ and ‘the weak’(14.1—15.13)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter24" title="Link target outside of Sample">24  Paul’s travel plans and the coming missionary task (15.14—16.2)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Chapter25" title="Link target outside of Sample">25  Final greetings, final appeal and doxology (16.3–27)</span></p>
<p class="bkfm-toc-ttl"><span href="#/Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index01" title="Link target outside of Sample"><i>Search items for biblical and patristic references</i></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index02" title="Link target outside of Sample"><i>Search names for modern authors</i></span></p>
<p class="bkfm-toc-ttl"><span href="#/Index03" title="Link target outside of Sample"><i>Search items for subjects</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_contents.vue?eb147f04